import { render, staticRenderFns } from "./ColorSelection.vue?vue&type=template&id=a8451696&scoped=true&"
import script from "./ColorSelection.vue?vue&type=script&lang=js&"
export * from "./ColorSelection.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelection.vue?vue&type=style&index=0&id=a8451696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8451696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8451696')) {
      api.createRecord('a8451696', component.options)
    } else {
      api.reload('a8451696', component.options)
    }
    module.hot.accept("./ColorSelection.vue?vue&type=template&id=a8451696&scoped=true&", function () {
      api.rerender('a8451696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/ColorSelection.vue"
export default component.exports